import React from "react";
import IconButton from "../IconButton/IconButton";

interface AddAndRemoveButtonsProps {
  children: React.ReactNode;
  hasError?: boolean;
  isLast: boolean;
  isFirst: boolean;
  onAdd: () => void;
  onRemove: () => void;
  alignItems?: string;
}

const AddAndRemoveButtons = ({
  children,
  hasError,
  isLast,
  isFirst,
  onAdd,
  onRemove,
  alignItems = "center",
}: AddAndRemoveButtonsProps) => {
  return (
    <div className="mb-4 flex gap-2" style={{ alignItems: hasError ? alignItems : "flex-end" }}>
      {children}
      <div className="my-2 flex w-30 items-center justify-start gap-2">
        {isLast && (
          <IconButton
            variants="plus"
            type="button"
            size="small"
            onClick={onAdd}
          />
        )}
        {!isFirst && (
          <IconButton
            variants="minus"
            type="button"
            size="small"
            onClick={onRemove}
          />
        )}
      </div>
    </div>
  );
};

export default AddAndRemoveButtons;
